// extracted by mini-css-extract-plugin
export default {"articleMain":"SectionArticleDefault_articleMain__IPibt","noSidePaddings":"SectionArticleDefault_noSidePaddings__QrYlE"};